import { FC, useEffect } from 'react';

import ButtonComponent from '../ButtonComponent';
import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

import { getRequestedLanguages } from '../../locale/languages';

interface Props {
    showModal: boolean;
    isLoading?: boolean;
    title?: string;
    classes?: string[];
    cancelButtonText?: string;
    confirmButtonText?: string;
    onClose?: () => void;
    onCancel?: () => void;
    onConfirm?: () => void;
    children?: React.ReactNode;
}

const ModalComponent: FC<Props> = ({
    showModal,
    isLoading = false,
    title,
    classes = [],
    cancelButtonText,
    confirmButtonText,
    onClose,
    onCancel,
    onConfirm,
    children,
}) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    useEffect(() => {
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            bodyElement.style.overflowY = showModal ? 'hidden' : 'scroll';
        }
    }, [showModal]);

    if (showModal) {
        return (
            <div className={`br-modal ${classes.join(' ')}`}>
                {isLoading ? (
                    <LoadingSpinnerComponent />
                ) : (
                    <div className="br-modal__container">
                        <div className="br-modal__container--titleRow">
                            <h2>{title}</h2>
                            {onClose ? <i className="br-icon-close" onClick={onClose}></i> : null}
                        </div>
                        {children}
                        <div className="br-modal__container--buttonsRow">
                            {onCancel ? (
                                <ButtonComponent
                                    text={cancelButtonText ?? language.modals.general.cancel}
                                    onClick={onCancel}
                                    style="outline"
                                />
                            ) : null}
                            {onConfirm ? (
                                <ButtonComponent
                                    text={confirmButtonText ?? language.modals.general.confirm}
                                    onClick={onConfirm}
                                    style="solid"
                                />
                            ) : null}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return null;
};

export default ModalComponent;
